import { GlobalFooter } from "@/patterns/global-footer/src/global-footer";

import { EnterprisePageProductNav } from "../../enterprise-landing-page/sections/enterprise-nav";

import ConstantSelector from "./sections/constant-selector";

export const EnterpriseContactSalesPageTemplate = () => {
    return (
        <div>
            <EnterprisePageProductNav />
            <div>
                <div>
                    {/* EnterpriseContactSalesPage content */}
                    <ConstantSelector />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
